<template>
  <div class="mb-4">
    <OperacionesCSVDashboard />
  </div>
</template>

<script>
import OperacionesCSVDashboard from "@/components/Widgets/OperacionesCSV/OperacionesCSVDashboard.vue";

export default {
  name: "OperacionesCSV",
  components: {
    OperacionesCSVDashboard,
  },
};
</script>

<style scoped lang="scss"></style>
